export async function handleCreatePdpLayoutWithProof(_msg, { commit, dispatch }) {
  commit('SET_PENDING_PROOF_AFTER_LAYOUT', true);
  commit('SET_AUTO_TRIGGER_CREATE_LAYOUT', true);

  await dispatch('addAndSaveMessage', {
    role: 'assistant',
    content: 'Creating your layout and generating a proof link. This may take a moment...',
  });
}
